document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector("#product-grid");
  if (!grid) return;

  let nextPage = 2;
  let loading = false;
  const pagination = document.querySelector(".pagination");
  if (pagination) pagination.style.display = "none";

  const loadNextPage = () => {
    if (loading) return;
    loading = true;

    // 🔹 SHOW loader
    document.body.classList.add("infinite-loading");

    const baseURL = window.location.pathname.split("?")[0];
    const url = `${baseURL}?page=${nextPage}`;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newItems = doc.querySelectorAll("#product-grid > li");

        if (newItems.length === 0) {
          window.removeEventListener("scroll", handleScroll);

          // 🔹 HIDE loader (no more products)
          document.body.classList.remove("infinite-loading");
          return;
        }

        newItems.forEach((item) => grid.appendChild(item));
        nextPage++;
        loading = false;

        // 🔹 HIDE loader (done loading)
        document.body.classList.remove("infinite-loading");
      })
      .catch(() => {
        loading = false;

        // 🔹 HIDE loader (error case)
        document.body.classList.remove("infinite-loading");
      });
  };

  const handleScroll = () => {
    const scrollPos = window.scrollY + window.innerHeight;
    const threshold = document.body.offsetHeight - 300;
    if (scrollPos >= threshold) loadNextPage();
  };

  window.addEventListener("scroll", handleScroll);
});
